module.exports = "<div class=\"search\">\r\n  <input type=\"text\" class=\"search__input\" (keyup)=\"onKeyUp($event)\"/>\r\n</div>\r\n"